<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 179.18 133.43">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <polygon points="28.22 31.25 73.96 77 150.96 0 179.18 28.22 73.96 133.43 0 59.47 28.22 31.25" fill="#fff" />
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// TickIcon.vue?1f14be2e